import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, withCredentials: true });
http.interceptors.response.use(undefined, async (err) => {
  const cfg = err.config || {};
  const isAuthCall = (cfg.url || "").startsWith("/auth/");
  if (err.response?.status === 401 && !cfg._retried && !isAuthCall) {
    cfg._retried = true;
    try {
      await http.post(`/auth/refresh`);
      return http(cfg);
    } catch {
      /* fall through to original error */
    }
  }
  throw err;
});

export const submitLead = (data) => http.post(`/leads`, data).then((r) => r.data);
export const submitSoaRequest = (data) => http.post(`/soa-requests`, data).then((r) => r.data);
export const fetchSoaRequests = () => http.get(`/soa-requests`).then((r) => r.data);
export const updateSoaStatus = (id, status) => http.patch(`/soa-requests/${id}/status`, { status }).then((r) => r.data);
export const fetchArticles = () => http.get(`/articles`).then((r) => r.data);
export const fetchArticle = (slug) => http.get(`/articles/${slug}`).then((r) => r.data);

export const adminLogin = (email, password) => http.post(`/auth/login`, { email, password }).then((r) => r.data);
export const googleSession = (session_id) => http.post(`/auth/google/session`, { session_id }).then((r) => r.data);
export const adminMe = async () => {
  try {
    return (await http.get(`/auth/me`)).data;
  } catch (err) {
    if (err.response?.status !== 401) throw err;
    await http.post(`/auth/refresh`);
    return (await http.get(`/auth/me`)).data;
  }
};
export const adminLogout = () => http.post(`/auth/logout`);
export const fetchLeads = () => http.get(`/leads`).then((r) => r.data);
export const archiveLead = (id) => http.post(`/leads/${id}/archive`).then((r) => r.data);
export const unarchiveLead = (id) => http.post(`/leads/${id}/unarchive`).then((r) => r.data);
export const updateLeadPriority = (id, priority) => http.patch(`/leads/${id}/priority`, { priority }).then((r) => r.data);
export const updateLeadFollowUp = (id, follow_up_date) => http.patch(`/leads/${id}/follow-up`, { follow_up_date }).then((r) => r.data);
export const archiveSoa = (id) => http.post(`/soa-requests/${id}/archive`).then((r) => r.data);
export const unarchiveSoa = (id) => http.post(`/soa-requests/${id}/unarchive`).then((r) => r.data);
export const updateSoaNotes = (id, notes) => http.patch(`/soa-requests/${id}/notes`, { notes }).then((r) => r.data);
export const updateSoaPriority = (id, priority) => http.patch(`/soa-requests/${id}/priority`, { priority }).then((r) => r.data);
export const updateSoaFollowUp = (id, follow_up_date) => http.patch(`/soa-requests/${id}/follow-up`, { follow_up_date }).then((r) => r.data);
export const fetchTeam = () => http.get(`/auth/team`).then((r) => r.data);
export const createTeamMember = (data) => http.post(`/auth/team`, data).then((r) => r.data);
export const setTeamMemberActive = (id, active) => http.patch(`/auth/team/${id}`, { active }).then((r) => r.data);
export const updateLeadStatus = (id, status) => http.patch(`/leads/${id}/status`, { status }).then((r) => r.data);
export const updateLeadNotes = (id, notes) => http.patch(`/leads/${id}/notes`, { notes }).then((r) => r.data);
export const sendDigestNow = () => http.post(`/digest/send`).then((r) => r.data);
export const exportLeads = () => http.get(`/leads/export`, { responseType: "blob" }).then((r) => r.data);
export const changePassword = (current_password, new_password) =>
  http.post(`/auth/change-password`, { current_password, new_password }).then((r) => r.data);
export const fetchNotificationSettings = () => http.get(`/settings/notifications`).then((r) => r.data);
export const saveNotificationSettings = ({ phone, email_quote, email_soa, sms_quote, sms_soa }) =>
  http.put(`/settings/notifications`, { phone, email_quote, email_soa, sms_quote, sms_soa }).then((r) => r.data);
export const sendTestSms = () => http.post(`/settings/notifications/test-sms`).then((r) => r.data);
export const resendLeadAlert = (id) => http.post(`/leads/${id}/resend-alert`).then((r) => r.data);
export const resendSoaAlert = (id) => http.post(`/soa-requests/${id}/resend-alert`).then((r) => r.data);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
